import storage from 'local-storage-fallback';

const useGetLocalStorage = (key: string) => {
  if (!storage) return JSON.parse('{}');
  return JSON.parse(storage?.getItem(key) || '{}');
};

export default useGetLocalStorage;
